module.exports = __webpack_public_path__ + "img/2026-09-21c_1.45ecbce1.jpg";